import CardRibbon from './CardRibbon'
import translate, { t } from '../../../utilities/translator';
import { memo, useCallback } from 'react';

const CardRibbons = ({
  data,
  specialDealLabel,
  dealItem
}) => {
  const ribbons = [];

  const israelCompanies = ['LY', 'IZ', 'BZ', '6H'];

  if (data.boardType === 'BB') {
    ribbons.push(<CardRibbon key="BB" text={t('dealItem.ribbon.breakfast_included')} />)
  }

  if (data.boardType === 'HB') {
    ribbons.push(<CardRibbon key="HB" text={t('dealItem.ribbon.half_board')} />)
  }

  if (data.boardType === 'FB') {
    ribbons.push(<CardRibbon key="FB" text={t('dealItem.ribbon.full_board')} />)
  }

  if (data.boardType === 'AI') {
    ribbons.push(<CardRibbon key="AI" type="all-inclusive" text={t('dealItem.ribbon.all_inclusive')} />);
  }

  if (
    window?.dataGlobalSettings?.marketId === 4 &&
    dealItem?.flight?.company_code &&
    dealItem?.flight?.inbound?.company_code &&
    israelCompanies.indexOf(dealItem?.flight?.company_code) > -1 &&
    israelCompanies.indexOf(dealItem?.flight?.inbound?.company_code) > -1
  ) {
    ribbons.push(<CardRibbon key="IC" type="special" text={t('dealItem.ribbon.israeliCompanies')} />);
  }

  if (data.lastMinute) {
    ribbons.push(<CardRibbon type="last-minute" text={t('dealItem.ribbon.last_minute')} />);
  }

  if (specialDealLabel) {
    ribbons.push(<CardRibbon key="special" type="special" text={specialDealLabel} />);
  }

  const showPersonalizedRibbon = useCallback(() => {
    if (data.hotelPreferencesMet.length > 0) {
      const randomIndex = Math.floor(Math.random() * data.hotelPreferencesMet.length);

      return (
        <CardRibbon type="personalized" text={translate(`ribbons.${data.hotelPreferencesMet[randomIndex]}`)} />
      )
    }
  }, [data.hotelPreferencesMet]);

  return (
    <div className="absolute-fix absolute top-4 flex flex-col items-start gap-1">
      {ribbons.slice(0, 2)}
      {showPersonalizedRibbon()}
    </div>
  )
}

export default memo(CardRibbons);
